import React from 'react';
import { useSelector } from 'react-redux';

import MobileFab from 'components/Layout/MobileShell/MobileFab';
import MobileListState from 'components/Layout/MobileShell/MobileListState';
import { selectMailerLayoutSearchQuery } from 'redux/reducers/mailerLayoutReducer';
import useReportSorting from 'utils/hooks/mailer/useReportSorting';
import useReportListing from 'utils/hooks/mailer/useReportListing';
import useListCompanies from 'utils/hooks/mailer/useListCompanies';

import ReportCard from './ReportCard';

import './index.scss';

export default function ReportsTableMobile({
  openReportForm,
}: {
  openReportForm: () => void,
}) {
  const searchQuery: string = useSelector(selectMailerLayoutSearchQuery);
  const [orderBy, orderDirection] = useReportSorting();
  const {
    reportList,
    isLoading,
    isFetching,
    listEnded,
  } = useReportListing({
    pageSize: 12,
    orderBy,
    orderDirection,
    searchQuery,
  });
  const { companies, isLoading: companiesLoading } = useListCompanies();

  const loading = isLoading || companiesLoading;
  const resultsCount = reportList?.length || 0;

  return (
    <div className="reports-mobile">
      <MobileListState
        loading={loading}
        isEmpty={resultsCount === 0}
        emptyMessage="Não foi encontrado nenhum relatório."
        infiniteScroll={{ fetchingMore: isFetching, listEnded }}
      >
        {reportList?.map((report) => (
          <ReportCard key={report.processId} report={report} companies={companies || []} />
        ))}
      </MobileListState>

      <MobileFab label="Novo relatório" onClick={openReportForm} />
    </div>
  );
}
